import script from "./GameTermsMain.vue?vue&type=script&setup=true&lang=js"
export * from "./GameTermsMain.vue?vue&type=script&setup=true&lang=js"

import "./GameTermsMain.vue?vue&type=style&index=0&id=660966d9&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-660966d9"]])

export default __exports__